import React, { useState } from "react";
import {
  Paper,
  IconButton,
  Typography,
  Modal,
  Box,
  Button,
  MenuItem,
  Divider,
  Avatar,
  Tooltip,
  Menu,
  ListItemIcon,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useAuth } from "../../context/AuthContext";
import { Logout } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ThemeToggleButton from "../../styles/editor/ThemeToggleEditor";

export const PanelHeader = ({ handleMenuToggle, nameDocument, userMe }) => {
  const { logout } = useAuth();
  const [showModal, setShowModal] = useState(false);

  const userName = userMe?.user_name || "Usuario";

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Paper
      elevation={0}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <IconButton onClick={handleMenuToggle}>
        <MenuIcon />
      </IconButton>

      <Typography
        variant="h5"
        align="center"
        gutterBottom
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: "25px",
          fontWeight: "600",
        }}
      >
        {nameDocument}
      </Typography>

      <div>
        <Box>
          <ThemeToggleButton/>
          <Tooltip title="Cuenta">
            <IconButton
              onClick={handleClick}
              size="small"
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <Avatar sx={{ width: 40, height: 40, bgcolor: "#235789" }}>
                {userName.charAt(0).toUpperCase()}
              </Avatar>
            </IconButton>
          </Tooltip>
        </Box>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem
            disableRipple
            sx={{
              pointerEvents: "none",
              backgroundColor: "transparent",
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <ListItemIcon>
              <AccountCircleIcon />
            </ListItemIcon>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ fontWeight: "600" }}>{userName}</span>
              <span style={{ fontSize: "12px" }}>{userMe?.rol}</span>
            </div>
          </MenuItem>

          <Divider />
          <MenuItem onClick={() => setShowModal(true)}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Cerrar Sesión
          </MenuItem>
        </Menu>
      </div>

      <ModalLogout
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        logout={logout}
      />
    </Paper>
  );
};

const ModalLogout = ({ isOpen, onClose, logout }) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton onClick={onClose} color="primary">
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography
          id="modal-modal-title"
          variant="h4"
          sx={{ textAlign: "center" }}
        >
          Cerrar sesión
        </Typography>
        <Typography
          id="modal-modal-description"
          sx={{ mt: 2, fontSize: "16px", textAlign: "center" }}
        >
          Si deseas salir haz clic en Cerrar Sesión o en Cancelar para seguir en
          la aplicación.
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              logout();
              onClose();
            }}
            sx={{ mr: 2 }}
          >
            Confirmar
          </Button>
          <Button variant="outlined" color="secondary" onClick={onClose}>
            Cancelar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
